import React from "react";
import smartDealGraphIcon from "../../../../../assets/inventory/smart-deal-graph.svg";
import InvSmartDealIcon from "assets/icon/inv-smart-deal.svg";
import { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import closeIcon from "../../../../../assets/icon/chatClose.svg";
import doubleArrow from "assets/icon/double-arrow-down.svg";
import InvOptimizationLocateProduct from "pages/Inventory/InvOptimizations/InvOptimizationLocateProduct";

const SmartDealModal = ({ closeButton }) => {
  const [showImg, setShowImg] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
  
  const [showRecommended, setShowRecommended] = useState(true);
  return (
    <div className="smart-deal-container" onClick={(e) => e.stopPropagation()}>
      <div className="smart-header-text" style={{ width: "88vw" }}>
        <div>Smart Deal</div>
        <div>
          <img
            className="cursor-pointer"
            onClick={closeButton}
            src={closeIcon}
          />
        </div>
      </div>
      <div style={{overflow:"auto",width: "88vw" }} className="mt-3" >
      <div className="optsnap-deal-cards" style={{ width: "87vw",marginBottom:"16px"}}>
        <div
          style={{
            paddingBottom: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            Current Product{" "}
            <span
              className="cursor-pointer"
              onClick={() => setShowImg(!showImg)}
            >
              {showImg ? (
                <img
                  src={doubleArrow}
                  style={{
                    transform: "rotate(180deg)",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                    marginLeft: "8px",
                    verticalAlign: "middle",

                  }}
                />
              ) : (
                <img
                  src={doubleArrow}
                  style={{
                    transition: "opacity 0.3s ease",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                />
              )}
            </span>
          </div>
          <Button color="primary" onClick={() => setModalOpen(true)}>
            Locate Product
          </Button>
        </div>
        <div className="section-devider-border-popup"></div>
        <div className="inv-smartdeal-img" >
          {showImg ? (
            <img
              style={{ width: "100%" }}
              src={InvSmartDealIcon}
              alt="not available"
            />
          ) : (
            <></>
          )}
        </div>
        <Row >
          <Col>
            <div className="inv-pdetails">Drug Name</div>
            <div className="sanp-drug-data">Lisinopril 10 MG Tablet</div>
          </Col>
          <Col>
            <div className="inv-pdetails">NDC</div>
            <div className="sanp-drug-data">68190-0513-01</div>
          </Col>
          <Col>
            <div className="inv-pdetails">Manufacturer</div>
            <div className="sanp-drug-data">Lupin Pharmacuticals</div>
          </Col>
          <Col>
            <div className="inv-pdetails">NDC</div>
            <div className="sanp-drug-data">McKesson</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="inv-pdetails">Package Price</div>
            <div className="sanp-drug-data">$ 89.50</div>
          </Col>
          <Col>
            <div className="inv-pdetails">Annual Usage</div>
            <div className="sanp-drug-data">48,000 Tablets</div>
          </Col>
          <Col>
            <div className="inv-pdetails">Annual Spend</div>
            <div className="sanp-drug-data">$ 4,296.00</div>
          </Col>
          <Col>
            <div className="inv-pdetails">Current On Hand</div>
            <div className="sanp-drug-data">1,398</div>
          </Col>
        </Row>
        <Row>
          <Col lg={3}>
            <div className="inv-pdetails">Par Level</div>
            <div className="sanp-drug-data">4000</div>
          </Col>
          <Col lg={4}>
            <div className="inv-pdetails">Last Ordered</div>
            <div className="sanp-drug-data">12/15/2024</div>
          </Col>
        </Row>
      </div>
   
          <div
            className="optsnap-deal-cards mb-3"
            style={{ width: "87vw", backgroundColor: "#DBCAD8" }}
          >
            <div
              style={{
                paddingBottom: showRecommended ? "8px" : "",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                Recommended Product Details{" "}
                <span
                  className="cursor-pointer"
                  onClick={() => setShowRecommended(!showRecommended)}
                >
                  {showRecommended ? (
                    <img
                      src={doubleArrow}
                      style={{
                        transform: "rotate(180deg)",
                        transition: "opacity 0.3s ease, transform 0.3s ease",
                        marginLeft:"8px", verticalAlign:"middle"
                      }}
                    />
                  ) : (
                    <img
                      src={doubleArrow}
                      style={{ transition: "opacity 0.3s ease", marginLeft:"8px", verticalAlign:"middle"}}
                    />
                  )}
                </span>
              </div>
            </div>
            {showRecommended ? (
              <>
                <div className="inv-section-devider-border-popup"></div>
                <Row>
                  <Col>
                    <div className="inv-pdetails">Drug Name</div>
                    <div className="sanp-drug-data">
                      Lisinopril 10 MG Tablet
                    </div>
                  </Col>
                  <Col>
                    <div className="inv-pdetails">NDC</div>
                    <div className="sanp-drug-data">68190-0513-01</div>
                  </Col>
                  <Col>
                    <div className="inv-pdetails">Manufacturer</div>
                    <div className="sanp-drug-data">Alembic Pharmacuticals</div>
                  </Col>
                  <Col>
                    <div className="inv-pdetails">Manufacturer</div>
                    <div className="sanp-drug-data">Anda</div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="inv-pdetails">Package Price</div>
                    <div className="sanp-drug-data">$ 36.50</div>
                  </Col>
                  <Col>
                    <div className="inv-pdetails">Projected Usage</div>
                    <div className="sanp-drug-data">48,000 Tablets</div>
                  </Col>
                  <Col>
                    <div className="inv-pdetails">Projected Spend</div>
                    <div className="sanp-drug-data">$ 1,752.00</div>
                  </Col>
                  <Col>
                    <div className="inv-pdetails">Substitution</div>
                    <div className="sanp-drug-data">AB Rated</div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <div className="inv-pdetails">Contract</div>
                    <div className="sanp-drug-data">N/A</div>
                  </Col>
                  <Col lg={4}>
                    <div className="inv-pdetails">Availability</div>
                    <div className="sanp-drug-data">In Stock</div>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
          </div>
      
      </div>
      <div
        className="create-manual-footer"
        style={{ width: "88vw", padding: "12px" }}
      >
        <div>
          <Button color="primary" className="reset" onClick={closeButton}>
            Back
          </Button>
        </div>
        <div className="d-flex">
          <Button className="back-button" onClick={closeButton}>
            Decline
          </Button>
          <Button color="primary" onClick={closeButton}>
            Accept
          </Button>
        </div>
      </div>
      {modalOpen && (
        <div className="smart-deal-backdrop">
          <InvOptimizationLocateProduct
            closeButton={() => setModalOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default SmartDealModal;
